import React, { useState } from 'react';
import { Box, Typography, TextField, Button, IconButton } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import dietService from '../../services/diet_service';

function AddDiet() {
  const [name, setName] = useState('');
  const [dietMenus, setDietMenus] = useState([{ menu: '', calories: '' }]);

  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleMenuChange = (index, event) => {
    const values = [...dietMenus];
    values[index]['menu'] = event.target.value;
    setDietMenus(values);
  };

  const handleCaloriesChange = (index, event) => {
    const values = [...dietMenus];
    values[index]['calories'] = event.target.value;
    setDietMenus(values);
  };

  const handleAddFields = () => {
    setDietMenus([...dietMenus, { menu: '', calories: '' }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...dietMenus];
    values.splice(index, 1);
    setDietMenus(values);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    let dietClassMenus = dietMenus.map(menu => ({
      menu_name: menu.menu,
      calories: menu.calories,
    }));
  
    const dietData = {
      name: name,
      diet_class_menus: dietClassMenus,
    };
  
    // call the service method instead of directly calling the backend API
    const response = await dietService.createDietWithMenu(dietData); 
    console.log('AddDiet.jsx - createDietWithMenu response:', response); // log the response here
    if (response.data) {
      alert("Diet class created successfully");
      navigate(-1); 
    } else {
      alert("An error occurred while creating the diet class");
    }
  };
  
  
  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Typography sx={{ fontFamily: 'Titillium Web',marginLeft: '280px' , mt: 2, fontWeight: 'bold' }} variant="h6" component="h3" color="#1C1C1E" mb={1}>
          Menambahkan Program Makanan
      </Typography>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Diet" />
      </Box>

      <Box sx={{ marginLeft:'280px', marginRight:'50px', p: 2 }}>
        <form onSubmit={handleSubmit}>

          {/* Input Name */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Name"
              value={name}
              onChange={handleNameChange}
              variant="outlined" />
          </Box>

          {dietMenus.map((dietMenu, index) => (
            <Box key={index}>
              {/* Input Menu */}
              <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
                <TextField
                  required
                  fullWidth
                  label="Menu"
                  value={dietMenu.menu}
                  onChange={event => handleMenuChange(index, event)}
                  variant="outlined" />
              </Box>

              {/* Input Calories */}
              <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
                <TextField
                  required
                  fullWidth
                  label="Calories"
                  type="number"
                  value={dietMenu.calories}
                  onChange={event => handleCaloriesChange(index, event)}
                  variant="outlined" />
              </Box>
              
              <IconButton onClick={() => handleRemoveFields(index)}><RemoveCircleIcon /></IconButton>
              <IconButton onClick={handleAddFields}><AddCircleIcon /></IconButton>
            </Box>
          ))}
          
          <Button type="submit" variant="contained" sx={{ boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white' }}>
            Tambahkan Diet
          </Button>
          <Button variant="contained" sx={{ left:10 , boxShadow: 5, textTransform: 'none', bgcolor: '#FF5630', color: 'white' }} onClick={handleCancel}>Cancel</Button>
        </form>
      </Box>
    </>
  );
}

export default AddDiet;